import { ORDER_STATE } from "../../model/quality.constant";
import { PipelineObject } from "../model/order-detail.model";

export class SetOrderLocked {
	static readonly type = '[Quality][Order][Detail] SetOrderLocked';

	constructor(
		public locked: Date,
		public lockedBy: {
			firstName: string;
			id: string;
			lastName: string;
		}
	) { }
}

export class SetOrderUnlocked {
	static readonly type = '[Quality][Order][Detail] SetOrderUnlocked';
}

export class SetOrderDetailPipelines {
	static readonly type = '[Quality][Order][Detail] SetOrderDetailPipelines';
	constructor(public pipelineConfig: Array<PipelineObject>) { }
}

export class SetOrderStateEnum {
	static readonly type = '[Quality][Order][Detail] SetOrderStateEnum';

	constructor(public stateEnum: ORDER_STATE) { }
}
